import React from 'react';
import { Box, Tooltip, IconSvg, IconSvgProps } from '@utex/ui-kit';
import { List } from '@utex/ui-kit/desktop';
import { NavItem } from '../NavItem';

export interface Languages {
  [key: string]: {
    icon: IconSvgProps['src'];
    text: string;
    nativeText: string;
  };
}

const iconLanguageSize = {
  width: 18,
  height: 18,
};

const languages: Languages = {
  en: {
    icon: 'language-en',
    text: 'English',
    nativeText: 'English',
  },
  ru: {
    icon: 'language-ru',
    text: 'Russian',
    nativeText: 'Русский',
  },
  es: {
    icon: 'language-es',
    text: 'Spanish',
    nativeText: 'Español',
  },
};

interface Props {
  locale: string;
  setLocale: (locale: string) => void;
  openLangModal?: () => void;
}

export const LanguageSwitcher: React.FC<Props> = (props) => {
  const { locale: currentLocale, setLocale, openLangModal } = props;

  return (
    <Tooltip
      position="top"
      width={284}
      offset={8}
      isArrow={false}
      padding={[10, 0]}
      trigger={
        <NavItem
          size="XS"
          view="hint"
          as="button"
          onClick={openLangModal}
          data-testid="menu-link-language"
        >
          <Box display="flex" alignItems="center" justifyContent="space-between">
            {languages[currentLocale]?.text}

            <Box marginLeft={20} lineHeight={0}>
              <IconSvg src={languages[currentLocale]?.icon} {...iconLanguageSize} />
            </Box>
          </Box>
        </NavItem>
      }
    >
      {(closeTooltip) => {
        return (
          <List paddingItems="1rem 1.6rem">
            <div>
              {Object.keys(languages).map((locale) => {
                const language = languages[locale];

                return (
                  <List.ItemButton
                    key={locale}
                    onClick={(e) => {
                      e.stopPropagation();
                      setLocale && setLocale(locale);
                      closeTooltip();
                    }}
                  >
                    <Box alignSelf="center" marginRight={10} as="span">
                      <IconSvg src={language.icon} {...iconLanguageSize} />
                    </Box>

                    <List.Name>{language.nativeText}</List.Name>

                    {currentLocale === locale && (
                      <List.IconSecond>
                        <IconSvg src="check" />
                      </List.IconSecond>
                    )}
                  </List.ItemButton>
                );
              })}
            </div>
          </List>
        );
      }}
    </Tooltip>
  );
};
